var map = {
	"./right_acrylic_Attach.png": 55187,
	"./right_acrylic_Block.png": 83241,
	"./right_acrylic_Bookmark.png": 3956,
	"./right_acrylic_Carabiner.png": 72617,
	"./right_acrylic_Card.png": 36002,
	"./right_acrylic_Cham.png": 27039,
	"./right_acrylic_Dwarf.png": 39966,
	"./right_acrylic_Fan.png": 63705,
	"./right_acrylic_FloorParts.png": 35592,
	"./right_acrylic_LampStand.png": 92912,
	"./right_acrylic_ShakerKeyring.png": 3901,
	"./right_acrylic_SolidBlock.png": 70088,
	"./right_acrylic_Stand.png": 40534,
	"./right_acrylic_Wheel.png": 98235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47961;